module.exports = __webpack_public_path__ + "media/images/pekarska_mapa_web_bez_pozadi-533e356d.svg";